import React, { memo } from 'react';
import { FeedbackFormElement, FeedbackFormElementSelect, FeedbackFormElementMultiScale, FeedbackForm } from '@types'
import styles from './Form.module.scss';

const checkIconData = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzNCAzNSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzRBQzdBIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMjguNjg3NSA5Ljg0Mzc1TDEzLjgxMjUgMjUuMTU2Mkw2LjM3NSAxNy41IiBzdHJva2Utd2lkdGg9IjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K';

const checkCircleIcon = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHJ4PSIxMiIgZmlsbD0iIzYyQzU5MCIvPjxwYXRoIGQ9Ik0xNi42OCA5TDEwLjIyNjcgMTUuMjEwM0w3IDEyLjEwNTIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+';
const getQuestionTemplate = (question: FeedbackFormElement, index: number) => {
  const isAssessable = question.type.toLowerCase().includes('assessable');
  const isMultiScale = question.type.toLowerCase().includes('multiscale');
  const options = (question as FeedbackFormElementSelect | FeedbackFormElementMultiScale)?.options;
  let optionsContent = '';
  if (isMultiScale) {
    const statements = (question as FeedbackFormElementMultiScale)?.statements;
    optionsContent = `
    <div class="table-box-op-multi-scale-table">
      <table cellpadding="0" cellspacing="0" class="op-multi-scale-table">
        <tbody>
          <tr class="heading" style="border-top: none;">
              <td style="border-left: none; border-top: none;" colspan="2"></td>
              ${(options || []).map((option) => `<td style="border-top: solid 1px #E1E1E1;">${option}</td>`).join('')}
          </tr>
          ${(statements || []).map((statement) => `
            <tr class="item">
              <td colspan="2">${statement.value}</td>
              ${(options || []).map((option) => isAssessable && option === statement.assessment
                ? `<td style="color: #34AC7A;"><img width="24" height="25.2" class="check" src="${checkIconData}"/></td>`
                : '<td></td>'
              ).join('')}
            </tr>`
          ).join('')}
        </tbody>
      </table>
    </div>`;
  } else {
    const assessments = (question as FeedbackFormElementSelect).assessments ?? [];
    optionsContent = options
      ? `
      <ol style="padding-inline-start: 25px; margin-bottom: 0;">
        ${options.map((option, index) => isAssessable && !!assessments[index]
          ? `<li style="color: #62C590; line-height: 24px; margin: 3px 0;font-weight: 600; position: relative;"><span style="font-weight: 600;font-size: 16px;color: #62C590; text-align: left;">${option}</span><div class="op-tick-box-relative"><img src="${checkCircleIcon}" width="24" height="24"/></div></li>`
          : `<li style="line-height: 24px; margin: 5px 0;"><span style="font-size: 16px;font-weight: 500;color: #4A4A4A; text-align: left;">${option}</span></li>`
        ).join('')}
      </ol>
      `
      : '';
  }
  return `<div class="op-question-wrapper page-break-avoid">
    <div class="op-question-wrapper-inner">
      <div class="op-bullet">
        Q${index + 1}
      </div>
      <div class="op-question-content">
        <div class="op-question-title">
          <div class="op-question-title-inner">${question.value}</div>
        </div>
        ${optionsContent}
      </div>
    </div>
  </div>`
};

export const QuestionTemplate = {
  key: '{{{QUESTIONS}}}',
  content: (formQuestions: FeedbackFormElement[]) => {
    return `
    
    `
  }
};

type Props = {
  jsonFormData: FeedbackForm;
};

const Questions = ({ jsonFormData }: Props) => {
  return (
    <div className={styles.divContainer}>
      <div dangerouslySetInnerHTML={{
        __html: `${(jsonFormData.elements || []).filter(f => !f.isSensitive && !f.doNotSendToTeacher)
                .map((question: FeedbackFormElement, index: number) => getQuestionTemplate(question, index)).join('')}
                <style>
              .op-question-title {
                  margin-bottom: 10px;
                  width: 100%;
                  position: relative;
              }
              .op-question-title-inner {
                  font-family: montserrat, sans-serif;
                  font-style: normal;
                  font-weight: 600;
                  font-size: 18px;
                  line-height: 22px;
                  color: #4A4A4A;
                  padding-right: 10px;
                  padding-top: 20px;
                  overflow-wrap: break-word;
                  word-wrap: break-word;
                  hyphens: auto;
                  overflow: hidden;
                  margin-left: 17px;
              }
      
              .op-tick-box {
                  font-family: montserrat;
                  font-style: normal;
                  font-weight: 600;
                  font-size: 12px;
                  line-height: 12px;
                  text-transform: uppercase;
                  background-color: #62C590;
                  padding: 8px 10px 5px 10px;
                  border-radius: 2px;
                  color: white;
                  white-space: nowrap;
                  position: absolute;
                  right: 0;
                  top: 16px;
                  max-width: 180px;
              }
      
              .op-tick-box-relative {
                  position: absolute;
                  left: -57px;
                  top: -1px;
                  width: 24px;
                  height: 24px;
              }
      
              .op-question-wrapper {
                  padding-top: 30px;
              }
      
              .page-break-avoid {
                  page-break-inside: avoid;
              }
      
              .op-question-wrapper-inner {
                  display: -webkit-box;
                  display: -webkit-flex;
                  display: flex;
                  -webkit-flex-direction: row;
                  flex-direction: row;
              }
      
              .op-q-type-titles {
                  font-weight: bold;
                  margin-bottom: 5px;
                  margin-right: 10px;
                  vertical-align: top;
                  display: inline-block;
                  margin-top: 15px;
              }
      
              .op-bullet {
                  width: 40px;
                  height: 40px;
                  border-radius: 40px;
                  border: solid 2px #FF8E4F;
                  position: relative;
                  display: inline-block;
                  margin-right: 10px;
                  vertical-align: top;
                  min-width: 40px;
                  font-weight: bolder;
                  font-size: 16px;
                  line-height: 36px;
                  text-align: center;
                  background-color: #fff;
              }
      
              .op-question-content {
                  display: inline-block;
                  width: calc(100% - 50px);
                  margin-top: -7px;
              }
      
              .op-multi-scale-table {
                  border-top: none;
                  border-left: none;
                  border-bottom: none;
                  border-right: none;
                  margin-top: 25px;
                  width: 100%;
              }
      
              .op-correct-answers-box {
                  font-family: montserrat, sans-serif;
                  position: absolute;
                  right: -30px;
                  top: 0px;
                  color: white;
                  width: 66px;
                  height: 66px;
                  border-bottom-left-radius: 3px;
                  border-top-left-radius: 3px;
                  text-align: center;
                  line-height: 66px
              }
      
              .op-not-correct {
                  background-color: #F03B3B;
              }
      
              .op-half-correct {
                  background-color: #FF8E4F;
              }
      
              .op-correct {
                  background-color: #34AC7A;
              }
      
              .table-box-op-multi-scale-table {
                  /*width: auto;*/
                  margin-top: 15px;
                  margin-left: 14px;
              }
      
              .op-multi-scale-table td {
                  padding: 8px;
                  font-weight: 500;
                  font-size: 13px;
                  line-height: 16px;
                  color: #4A4A4A;
              }
      
              .op-multi-scale-table tr {
                  /*border-bottom: solid 1px lightgray;*/
              }
      
              .table-box-op-multi-scale-table tr.heading td {
                  text-align: center;
              }
      
              .table-box-op-multi-scale-table .item td:first-child {
                  border-right: solid 1px lightgray;
              }
      
              .table-box-op-multi-scale-table .heading td:first-child {
                  border-right: solid 1px lightgray;
              }
      
              .table-box-op-multi-scale-table .heading td, .item td {
                  border-bottom: solid 1px lightgray;
              }
      
              .table-box-op-multi-scale-table .heading td {
                  border-right: solid 1px lightgray;
              }
      
              .table-box-op-multi-scale-table .heading td:first-child {
                  border-left: solid 1px lightgray;
              }
      
              .table-box-op-multi-scale-table .item td {
                  border-right: solid 1px lightgray;
              }
      
              .table-box-op-multi-scale-table .item td:first-child {
                  border-left: solid 1px lightgray;
              }
      
              .table-box-op-multi-scale-table .item td:not(:first-child) {
                  text-align: center;
              }
      
              .table-box {
                  margin-top: 48px;
              }
      
              .table-box table, .summary-box table {
                  width: 100%;
                  font-family: montserrat, sans-serif;
                  font-style: normal;
                  font-size: 16px;
                  line-height: 20px;
              }
      
              .table-box td, .summary-box td  {
                  text-align: center;
              }
      
      
              .table-box td:first-child, .summary-box td:first-child  {
                  text-align: left;
              }
      
              .table-box td:last-child, .summary-box td:last-child {
                  text-align: center;
              }
      
              .table-box table tr.heading td {
                  border-top: 2px solid #E3E3E3;
                  border-bottom: 2px solid #E3E3E3;
                  height: 38px;
                  font-family: montserrat, sans-serif;
                  font-weight: bold;
                  font-size: 16px;
                  line-height: 24px;
              }
      
              .table-box table tr.item td, .summary-box table tr.item td {
                  border-bottom: 1px solid #E1E1E1;
                  height: 40px;
                  font-family: montserrat, sans-serif;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
              }
          </style>
                `
        }}
      />
    </div>
  )
}

export default memo(Questions);